export { default } from './EventListing';
